import { Blobatar } from "@blobatar/react";

type ProfileAvatarProps = {
  initials: string;
  seed?: string;
  size?: "menu" | "hero";
  className?: string;
};

const avatarSizes: Record<NonNullable<ProfileAvatarProps["size"]>, number> = {
  menu: 44,
  hero: 96,
};

export const ProfileAvatar = ({ initials, seed, size = "menu", className = "" }: ProfileAvatarProps) => {
  const normalizedInitials = initials.trim().slice(0, 2) || "U";
  const avatarName = seed?.trim() || normalizedInitials;

  return <Blobatar
    name={avatarName}
    size={avatarSizes[size]}
    alt={normalizedInitials}
    className={["shrink-0 overflow-hidden rounded-full border-2 border-[var(--ds-ground)]", className].join(" ")}
  />;
};
